import {AxisHoverParam} from "@atiautomacao/ati-ui-library";
import {format, isValid} from "date-fns";

const EMPTY_VALUE = "-";

// Duas casas decimais e sinal explícito (SGD-3844): +12,34 / -12,34. Zero (inclusive -0,004
// arredondado) fica sem sinal: 0,00.
const positionFormatter = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    signDisplay: "exceptZero"
});

/** Ordenação alfabética/numérica dos trackers (TK-2 antes de TK-10), desempatando por caixa. */
export const compareTrackerNames = (left: string, right: string): number => {
    const naturalOrder = left.localeCompare(right, undefined, {numeric: true, sensitivity: "base"});
    if (naturalOrder !== 0) {
        return naturalOrder;
    }
    return left.localeCompare(right, undefined, {numeric: true, sensitivity: "variant"});
};

export const formatTrackerPosition = (value: unknown): string => {
    // Em eixo 'time' o value do hint vem como [x, y].
    const rawValue = Array.isArray(value) ? value[1] : value;
    if (rawValue === null || rawValue === undefined || rawValue === "" || rawValue === EMPTY_VALUE) {
        return EMPTY_VALUE;
    }
    const numericValue = Number(rawValue);
    return Number.isFinite(numericValue) ? positionFormatter.format(numericValue) : EMPTY_VALUE;
};

export const formatTrackerHintHeader = (param: AxisHoverParam): string => {
    const date = new Date(param.axisValue);
    if (typeof param.axisValue === "number" && isValid(date)) {
        return format(date, "HH:mm");
    }
    return String(param.axisValueLabel ?? param.axisValue ?? "");
};

export const sortTrackerHintParams = (params: AxisHoverParam[] | null): AxisHoverParam[] | null => (
    params
        ? [...params].sort((left, right) => (
            compareTrackerNames(String(left.seriesName ?? ""), String(right.seriesName ?? "")) ||
            left.seriesIndex - right.seriesIndex
        ))
        : null
);
